import React from 'react'
import { useViewport } from '../../utils';
import recharts from './recharts';
const {
  PieChart,
  Pie,
  Cell
} = recharts

const DonutChart = ({data, total, colors}) => {
  const { isMobile } = useViewport()
  const size = isMobile ? 111 : 123

  return (
    <div>
      <PieChart width={size} height={size}>
        <Pie
          data={data}
          cx={size/2.05}
          cy={size/2.05}
          innerRadius={size/2.6}
          outerRadius={size/2.1}
          fill="#8884d8"
          paddingAngle={2}
          dataKey="value"
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[data.length === colors.length ? index : index % colors.length ]} />)
          }
        </Pie>
      </PieChart>
    </div>
  )
}

export { DonutChart }
